import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import {
  LoadingState,
  NotificationService,
} from '../../../core/services/notification/notification.service';

/**
 * T11 — Fullscreen loading overlay. Subscribes to `loadingState$`
 * and renders a centered spinner with optional message.
 */
import { CommonModule } from '@angular/common';

@Component({
  standalone: true,
    imports: [CommonModule],
  selector: 'app-notification-loading-overlay',
  templateUrl: './notification-loading-overlay.component.html',
  styleUrls: ['./notification-loading-overlay.component.scss'],
})
export class NotificationLoadingOverlayComponent implements OnInit, OnDestroy {
  state: LoadingState | null = null;

  private sub?: Subscription;

  constructor(private notificationService: NotificationService) {}

  ngOnInit(): void {
    this.sub = this.notificationService.loadingState$.subscribe((s) => {
      this.state = s;
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }
}
